module.exports = __webpack_public_path__ + "img/Mauritania.2b321774.gif";